module.exports = __webpack_public_path__ + "img/vocal-remover.d13eb981.png";